import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Carousel from "react-bootstrap/Carousel";


import About from "./About";
import FeaProduct from "../Product/FeaturedProduct";
import Result from "./Result"; 
import Product_single from "./Product_single"; 
import WhyChoose from "./whychoose"; 
import Testmonial from "./Testmonial"; 

// ✅ Import your banner images
import banner_img1 from "../Assets/Images/banner_img1.png";
import banner_img2 from "../Assets/Images/banner_img2.png";

const Banner_Main = () => {
  return (
    <>
      <div className="banner-sec">
        <Container fluid>
          <Row>
            <Col lg={12} className="p-0">
              <div className="banner-content-main">
                <Carousel
                  interval={3000} // auto slide
                  pause={false} // hover pe stop na ho
                  controls={true} // arrows enable
                  indicators={true} // dots enable
                  touch={true} // mobile swipe enable
                >
                  {/* SLIDE 1 */}
                  <Carousel.Item>
                    <div className="position-relative">
                      <img
                        src={banner_img1}
                        alt="Banner 1"
                        className="d-block banner_img"
                      />

                      <div className="banner-content">
                        <h2>Restore Your Health, Naturally.</h2>
                        <p>
                          Premium Ayurvedic Solutions Made from 100% Natural
                          Ingredients
                        </p>
                        <div className="banner_btn banner_img">
                            <a href="product" className="btn_banner">
                                Shop Now
                            </a>
                        </div>
                      </div>
                    </div>
                  </Carousel.Item>

                  {/* SLIDE 2 */}
                  <Carousel.Item>
                    <div className="position-relative">
                      <img
                        src={banner_img2}
                        alt="Banner 2"
                        className="d-block banner_img"
                      />

                      <div className="banner-content">
                        <div className="banner_btn banner_btn2">
                            <a href="product" className="btn_banner">
                                Shop Now
                            </a>
                        </div>
                      </div>
                    </div>
                  </Carousel.Item>
                </Carousel>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

    
      <About />
      <FeaProduct />
      <Result />
      <Product_single />
      <WhyChoose />
      <Testmonial />
    </>
  );
};

export default Banner_Main;
